import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {SearchTypeCart, TSearchTypeCart} from './constants';
import {cartRuleDefaults} from './defaults';
import type {CartRule} from './types';

export class CartRuleModel
	extends RuleModel<TSearchTypeCart>
	implements CartRule
{
	readonly elementType = SearchTypeCart;
	elementSubType1: 0 = cartRuleDefaults.elementSubType1;
	elementSubType2: 0 = cartRuleDefaults.elementSubType2;
	elementValue1 = cartRuleDefaults.elementValue1;
	elementValue2: '' = cartRuleDefaults.elementValue2;
	elementValue3: '' = cartRuleDefaults.elementValue3;

	get isValid() {
		return true;
	}

	constructor(params?: Partial<Omit<CartRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...cartRuleDefaults, ...params});
		});

		makeObservable(this, {
			isValid: computed,
			elementValue1: observable,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set cart id
	 * @param elementValue1 cart id
	 */
	setElementValue1(elementValue1: number) {
		this.elementValue1 = elementValue1;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default CartRuleModel;
